import { render, staticRenderFns } from "./BannerInfoLeilao.vue?vue&type=template&id=d0bc0164&scoped=true"
import script from "./BannerInfoLeilao.vue?vue&type=script&lang=js"
export * from "./BannerInfoLeilao.vue?vue&type=script&lang=js"
import style0 from "./BannerInfoLeilao.vue?vue&type=style&index=0&id=d0bc0164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bc0164",
  null
  
)

export default component.exports